module.exports = __webpack_public_path__ + "static/sfv-932717b231b11801df497bdb79d8e6cc.png";